import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const OrganicPadsSensitiveSkin = () => {
  useMetaTags({
    title: "Why Organic Pads Are Better for Sensitive Skin | Hypoallergenic Menstrual Care",
    description: "Discover how organic pads provide a hypoallergenic, chemical-free solution for sensitive skin. Reduce rashes and irritation with breathable cotton pads for a healthier period experience.",
    keywords: "organic pads, sensitive skin, hypoallergenic sanitary pads, menstrual care, chemical-free period products, breathable cotton pads",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/organic-pads-sensitive-skin",
    ogTitle: "Why Organic Pads Are Better for Sensitive Skin",
    ogDescription: "Organic pads are the best choice for sensitive skin, offering hypoallergenic, chemical-free protection. Say goodbye to irritation and rashes with breathable cotton pads.",
    ogImage: "https://images.pexels.com/photos/3958547/pexels-photo-3958547.jpeg?auto=compress&cs=tinysrgb&w=600",
    ogUrl: "https://organicpads.shop/organic-pads-sensitive-skin",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "Why Organic Pads Are Better for Sensitive Skin",
    twitterDescription: "Protect your sensitive skin with hypoallergenic organic pads. Experience a rash-free, comfortable period with breathable cotton pads.",
    twitterImage: "https://images.pexels.com/photos/3958547/pexels-photo-3958547.jpeg?auto=compress&cs=tinysrgb&w=600",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/organic-pads-sensitive-skin"
    },
    "headline": "Why Organic Pads Are Better for Sensitive Skin",
    "description": "Discover how organic pads provide a hypoallergenic, chemical-free solution for sensitive skin. Reduce rashes and irritation with breathable cotton pads for a healthier period experience.",
    "image": "https://images.pexels.com/photos/3958547/pexels-photo-3958547.jpeg?auto=compress&cs=tinysrgb&w=600",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "organic pads",
      "sensitive skin",
      "hypoallergenic sanitary pads",
      "menstrual care",
      "chemical-free period products",
      "breathable cotton pads"
    ]
  }

  return (
    <>
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">
        Why Organic Pads Are Better for Sensitive Skin
      </h1>
      <img
        src="https://images.pexels.com/photos/3958547/pexels-photo-3958547.jpeg?auto=compress&cs=tinysrgb&w=600"
        alt="Sensitive Skin Care"
        className="w-full rounded-lg mb-4"
      />
      <p className="text-gray-700 mb-4">
        For those with sensitive skin, choosing the right menstrual products is crucial. Organic pads offer a gentle, natural alternative that minimizes irritation and promotes better skin health during your period. Made without harsh chemicals, they're the perfect choice for sensitive skin care.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Benefits for Sensitive Skin</h2>
      <ul className="list-disc list-inside text-gray-700 mb-4">
        <li>Hypoallergenic natural materials</li>
        <li>No synthetic fragrances or irritants</li>
        <li>Breathable cotton construction</li>
        <li>Reduced risk of rashes</li>
        <li>Better moisture management</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">How to Care for Sensitive Skin?</h2>
      <p className="text-gray-700 mb-4">
        Choose <strong>hypoallergenic certified</strong> organic pads and avoid products with artificial additives. Regular changes and proper intimate hygiene enhance the benefits of using organic products.
      </p>
      <img
        src="https://plus.unsplash.com/premium_photo-1702598576513-fe7425ebf6bd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fG9yZ2FuaWMlMjBzYW5pdGFyeSUyMHBhZHN8ZW58MHx8MHx8fDA%3D.jpg"
        alt="Organic Care"
        className="w-full rounded-lg mb-4"
      />

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Final Thoughts</h2>
      <p className="text-gray-700 mb-4">
        Give your sensitive skin the care it deserves.
        <strong> Experience the comfort of organic pads today!</strong>
      </p>
    </div>
    {/* Schema Markup */}
    <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default OrganicPadsSensitiveSkin;
